module.exports = __webpack_public_path__ + "img/logo4.3f55b45c.png";